import React, { useEffect, useMemo, useState } from 'react';
import { useParams, useLocation } from 'react-router-dom';
import './explore-header.css';
import { getImageConfig, ImageConfig } from '../../../api/adserver';
import { DEFAULT_BUILDING } from '../../../lib/constants';
import Loading from '../../../assets/loading-buffering.gif';

interface Params {
  building_id: string;
}
import { sendScreenAnalytics } from '../headerHelper';

// For analytics
const Header: React.FC = () => {
  const location = useLocation();

  useEffect(() => {
    sendScreenAnalytics(location.pathname)
      .then(() => {
        console.log('done');
      })
      .catch((err) => {
        console.error(err);
      });
  }, [location]);

  const [imageData, setImageData] = useState<ImageConfig>();
  const [isLoading, setIsLoading] = useState<boolean>(false);

  const { building_id } = useParams<Params>();

  useEffect(() => {
    let buildingCode: string;
    if (!building_id) {
      buildingCode = DEFAULT_BUILDING;
    } else {
      buildingCode = building_id;
    }
    setIsLoading(true);
    getImageConfig(buildingCode)
      .then((res: any) => {
        if (res && res.headerImage) {
          setImageData(res.headerImage);
        } else {
          throw Error('no image');
        }
        setIsLoading(false);
      })
      .catch((e: any) => {
        setImageData({
          url: 'https://www.zonetail.com/wp-content/uploads/2018/09/Zonetail-Logo.svg',
          alternativeText: 'Zonetail Logo',
        });
        setIsLoading(false);
        console.log(e);
      });
  }, [building_id]);

  return (
    <div className="header explore-header">
      <div className="image">
        {isLoading ? (
          <img src={Loading} alt="loading" height={35} />
        ) : (
          <img
            // original default values
            // src="https://www.zonetail.com/wp-content/uploads/2018/09/Zonetail-Logo.svg"
            // alt="Zonetail logo"
            // width={135}
            // height={30}
            src={imageData?.url}
            alt={
              imageData && imageData.alternativeText
                ? imageData.alternativeText
                : ''
            }
            height={35}
          />
        )}
      </div>
    </div>
  );
};

export default Header;
